import create from 'zustand';

type RouteStoreType = {
  route: { [key: string]: any }
  activities: { [key: string]: any }[]
  history: { [key: string]: any }[]
  query: {
    refetch: () => void
    isLoading: boolean
  }
  lastActivity: {
    drivers?: any[]
    vehicle?: any
  }
  setRoute: (_: any) => void
  setLastActivity: (_: any) => void
  setActivities: (_: any) => void
  setHistory: (_: any) => void
  setQuery: (_: any) => void
}

const useRouteStore = create<RouteStoreType>((set) => ({
  route: { },
  activities: [],
  history: [],
  lastActivity: { },
  query: {
    refetch: () => null,
    isLoading: false,
  },
  setRoute: (data) => set(() => ({ route: data })),
  setActivities: (data) => set(() => ({ activities: data })),
  setLastActivity: (data) => set(() => ({ lastActivity: data })),
  setHistory: (data) => set(() => ({ history: data })),
  setQuery: (data) => set(() => ({ query: data })),
}));

export default useRouteStore;
